// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"OD-z","smallCardRow":"PD-z","largeCardRow":"QD-z","productSearchRow":"RD-z","curatedRow":"SD-z"};